import {
    REQUEST_MOVIES_BOX_OFFICE,
    MOVIES_BOX_OFFICE_SUCCEEDED,
    MOVIES_BOX_OFFICE_FAILED,
    REQUEST_MOVIES_BOX_OFFICE_HOME,
    MOVIES_BOX_OFFICE_SUCCEEDED_HOME,
    REQUEST_DATES,
    REQUEST_DATES_SUCCEEDED,
    REQUEST_DATES_FAILED,
    BOX_OFFICE_DISTRIBUTORS,
    BOX_OFFICE_DISTRIBUTORS_SUCCEEDED,
    BOX_OFFICE_STUDIOS_SUCCEEDED,
    BOX_OFFICE_STUDIOS
} from './types';

export const requestMoviesBoxOffice = (payload) => ({
    type: REQUEST_MOVIES_BOX_OFFICE,
    payload,
});

export const moviesBoxOfficeSuccess = (payload) => ({
    type: MOVIES_BOX_OFFICE_SUCCEEDED,
    payload,
});

export const moviesBoxOfficeFailed = (payload) => ({
    type: MOVIES_BOX_OFFICE_FAILED,
    payload,
});

export const requestMoviesBoxOfficeHome = (payload) => ({
    type: REQUEST_MOVIES_BOX_OFFICE_HOME,
    payload,
});

export const moviesBoxOfficeHomeSuccess = (payload) => ({
    type: MOVIES_BOX_OFFICE_SUCCEEDED_HOME,
    payload,
});

export const requestDates = (payload) => ({
    type: REQUEST_DATES,
    payload
});

export const requestDatesSuccess = (payload) => ({
    type: REQUEST_DATES_SUCCEEDED,
    payload,
});

export const requestDatesFailed = (payload) => ({
    type: REQUEST_DATES_FAILED,
    payload,
});

export const getBoxOfficeDistributors = (payload) => ({
    type: BOX_OFFICE_DISTRIBUTORS,
    payload
});

export const getBoxOfficeDistributorsSucceeded = (payload) => ({
    type: BOX_OFFICE_DISTRIBUTORS_SUCCEEDED,
    payload,
});

export const getBoxOfficeStudios = (payload) => ({
    type: BOX_OFFICE_STUDIOS,
    payload
});

export const getBoxOfficeStudiosSucceeded = (payload) => ({
    type: BOX_OFFICE_STUDIOS_SUCCEEDED,
    payload,
});





// WEBPACK FOOTER //
// ./src/SHARED/actions/boxoffice.actions.js